// extracted by mini-css-extract-plugin
export var checkMark = "CategorySelect-module--checkMark--G4OhF";